import React, { lazy } from 'react'

import { RouteObject } from 'react-router'

const Login = lazy(() => import('../containers/auth/login'))
const FirstLogin = lazy(() => import('../containers/auth/first'))
const Forgot = lazy(() => import('../containers/auth/forgot'))
const PasswordReset = lazy(() => import('../containers/auth/password.reset'))
const LoginTfa = lazy(() => import('../containers/auth/tfa'))
const SetupTfa = lazy(() => import('../containers/auth/tfa.setup'))
const Signup = lazy(() => import('../containers/auth/signup'))

const AuthRouter: RouteObject[] = [
    {
        path: '/login',
        element: <Login/>
    },
    {
        path: '/login/first',
        element: <FirstLogin/>
    },
    {
        path: '/forgot-password',
        element: <Forgot/>
    },
    {
        path: '/password-reset',
        element: <PasswordReset/>
    },
    {
        path: '/login/tfa',
        element: <LoginTfa/>
    },
    {
        path: '/login/tfa/setup',
        element: <SetupTfa/>
    },
    {
        path: '/signup',
        element: <Signup/>
    }
]

export default AuthRouter
